import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const RecordPaperSignature = graphql.persisted(
  "RecordPaperSignature",
  graphql(`mutation RecordPaperSignature($input: RecordPaperSignatureInput!) {
    recordPaperSignature(input: $input) {
      item { id state completedAt completedVia }
      errors
    }
  }`)
);

export { RecordPaperSignature };
export function useRecordPaperSignature() {
  return useMutation(RecordPaperSignature);
}
